<template>
    <v-dialog v-model="dialog" max-width="500" persistent>
        <v-card>
            <v-card-title class="d-flex align-center pa-4">
                <v-icon :icon="isEdit ? 'mdi-account-edit' : 'mdi-account-plus'" class="mr-2" color="primary" />
                {{ isEdit ? 'Modifica utente' : 'Nuovo utente' }}
                <v-spacer />
                <v-btn icon="mdi-close" variant="text" @click="chiudi" />
            </v-card-title>

            <v-divider />

            <v-card-text class="pa-4">
                <v-form ref="formRef" v-model="formValido">
                    <v-text-field v-model="form.userName" label="Nome utente" prepend-inner-icon="mdi-account"
                        variant="outlined" density="compact" class="mb-3" :rules="[regole.required, regole.minLen]"
                        autocomplete="off" />
                    <v-text-field v-model="form.eMail" label="Indirizzo email" prepend-inner-icon="mdi-email"
                        variant="outlined" density="compact" :rules="[regole.required, regole.email]"
                        autocomplete="off" />
                    <v-alert v-if="!isEdit" type="info" variant="tonal" density="compact" class="mt-2"
                        text="Verrà inviata una mail all'utente con il link per impostare la password." />

                    <v-checkbox class="compact-checkbox" label="Notifiche creazione rilievi" color="primary"
                        v-model="form.notificaNuovoRilievo" density="compact">
                        <template #details>
                            <div class="text-caption text-medium-emphasis" style="margin-top: -8px;">
                                Riceverai una notifica ogni volta che viene creato un nuovo rilievo nel sistema.
                            </div>
                        </template>
                    </v-checkbox>
                </v-form>
            </v-card-text>

            <v-divider />

            <v-card-actions class="pa-4">
                <v-spacer />
                <v-btn variant="text" @click="chiudi">Annulla</v-btn>
                <v-btn color="primary" variant="elevated" :loading="loading" :disabled="!formValido" @click="salva">
                    {{ isEdit ? 'Salva modifiche' : 'Crea utente' }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { crea_utente, modifica_utente } from '@/api/api.amministrazione'

export default {
    name: 'DialogoUtente',

    emits: ['salvato'],

    data() {
        return {
            dialog: false,
            loading: false,
            formValido: false,
            isEdit: false,
            utenteId: null,
            form: {
                userName: '',
                eMail: '',
                notificaNuovoRilievo: true,
            },
            regole: {
                required: v => !!v || 'Campo obbligatorio',
                minLen: v => (v && v.length >= 3) || 'Minimo 3 caratteri',
                email: v => /.+@.+\..+/.test(v) || 'Email non valida',
            }
        }
    },

    methods: {
        apri(utente = null) {
            this.isEdit = !!utente
            this.utenteId = utente?.userID ?? null
            this.form = {
                userName: utente?.userName ?? '',
                eMail: utente?.eMail ?? '',
                notificaNuovoRilievo: utente?.notificaNuovoRilievo ?? true
            }
            this.dialog = true
            this.$nextTick(() => this.$refs.formRef?.resetValidation())
        },

        chiudi() {
            this.dialog = false
            this.loading = false
        },

        async salva() {
            const { valid } = await this.$refs.formRef.validate()
            if (!valid) return

            this.loading = true
            try {
                if (this.isEdit) {
                    await modifica_utente(this.utenteId, this.form)
                } else {
                    await crea_utente(this.form)
                }
                this.$emit('salvato')
                this.chiudi()
            } catch {
                // la gestione errori è affidata all'interceptor
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style scoped>
.compact-checkbox .v-input__details {
    margin-top: 2px;
    padding-top: 0;
}
</style>